enum CountryCode {
  None = '',
  Canada = 'CA',
  UnitedStates = 'US',
  Australia = 'AU',
  Austria = 'AT',
  Belgium = 'BE',
  Brazil = 'BR',
  China = 'CN',
  Croatia = 'HR',
  Cyprus = 'CY',
  Denmark = 'DK',
  Estonia = 'EE',
  Finland = 'FI',
  France = 'FR',
  Germany = 'DE',
  Greece = 'GR',
  HongKong = 'HK',
  India = 'IN',
  Ireland = 'IE',
  Israel = 'IL',
  Italy = 'IT',
  Japan = 'JP',
  Latvia = 'LV',
  Lithuania = 'LT',
  Malta = 'MT',
  Mexico = 'MX',
  Netherlands = 'NL',
  NewZealand = 'NZ',
  Norway = 'NO',
  Philippines = 'PH',
  Poland = 'PL',
  Portugal = 'PT',
  RussianFederation = 'RU',
  Singapore = 'SG',
  Slovakia = 'SK',
  Slovenia = 'SI',
  SouthAfrica = 'ZA',
  SouthKorea = 'KR',
  Spain = 'ES',
  Sweden = 'SE',
  Switzerland = 'CH',
  Taiwan = 'TW',
  UnitedArabEmirates = 'AE',
  UnitedKingdom = 'UK',
}

export default CountryCode;
